import { Colors } from '../consts/Colors.js';
import { Fonts } from '../consts/Fonts.js';
import { Sizes } from '../consts/Sizes.js';
import AbstractScene from './AbstractScene.js';
import ButtonRounded from '../prefabs/ButtonRounded.js';

export default class End extends AbstractScene {
    constructor() {
        super({
            key: 'End',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.PaleWhite);

        // Afficher l’image
        this.add.image(0, 0, 'background').setOrigin(0);

        // ajouter fleches animées
        this.addAnimatedArrows();

        // set downloadMemo to true
        this.game.data.downloadMemo = true;

        scormComplete(true);
        scormSucceeded(true);
        setScormData(100);

        // texts
        const title = this.add
            .text(400, this.height / 2 - 350, 'Congratulations!', {
                fontFamily: Fonts.Text.h1,
                fontSize: Sizes.Text.h1,
                fill: Colors.Text.White,
                wordWrap: { width: 600 },
            })
            .setAlpha(0);

        const subtitle = this.add
            .text(
                400,
                this.height / 2 - 100,
                'You have successfully completed this e-learning course.',
                {
                    fontFamily: Fonts.Text.h4,
                    fontSize: Sizes.Text.h2,
                    fill: Colors.Text.LightBlue,
                    wordWrap: { width: 800 },
                }
            )
            .setAlpha(0);

        // Bouton "Download the memo"
        this.btnDownload = this.add
            .existing(
                new ButtonRounded(
                    this,
                    400 + 200,
                    this.height / 2 + 100,
                    420,
                    76,
                    'DOWNLOAD THE MEMO',
                    Colors.Text.Blue,
                    Colors.Elmt.Yellow,
                    true,
                    Colors.Elmt.Yellow,
                    true,
                    true,
                    'download',
                    ''
                )
            )
            .setAlpha(0);

        // Bouton "Back to menu"
        this.btnBackToMenu = this.add
            .existing(
                new ButtonRounded(
                    this,
                    400 + 200,
                    this.height / 2 + 210,
                    420,
                    76,
                    'BACK TO MENU',
                    Colors.Text.Blue,
                    Colors.Elmt.Yellow,
                    true,
                    Colors.Elmt.Yellow,
                    true,
                    true,
                    'fleche',
                    ''
                )
            )
            .setAlpha(0);

        // Bouton "Close"
        this.btnClose = this.add
            .existing(
                new ButtonRounded(
                    this,
                    400 + 200,
                    this.height / 2 + 320,
                    400,
                    76,
                    'CLOSE',
                    Colors.Text.Blue,
                    Colors.Elmt.Yellow,
                    true,
                    Colors.Elmt.Yellow,
                    true,
                    true,
                    'close',
                    ''
                )
            )
            .setAlpha(0);

        const subtitle2 = this.add
            .text(
                400,
                this.height / 2 + 420,
                'Don’t forget to click on close to validate your module.',
                {
                    fontFamily: Fonts.Text.h4,
                    fontSize: Sizes.Text.h3,
                    fill: Colors.Text.White,
                    wordWrap: { width: 800 },
                }
            )
            .setAlpha(0);

        // Robot image
        const endRobot = this.add
            .image(this.width - 670, this.height / 2 + 100, 'introRobot')
            .setOrigin(0, 0.5)
            .setScale(0);

        // Animate robot coming from the right and back (scale up as it moves closer)
        endRobot.setPosition(this.width + 100, this.height + 100).setScale(0.5);
        this.tweens.add({
            delay: 500,
            targets: endRobot,
            x: this.width / 2 + 500,
            y: this.height / 2 + 100,
            scale: 0.5,
            duration: 700,
            ease: 'Power2',
            onComplete: () => {
                this.tweens.add({
                    targets: endRobot,
                    x: this.width / 2 + 400,
                    y: this.height / 2 + 100,
                    scale: 1,
                    duration: 1000,
                    ease: 'Back.In',
                    onComplete: () => {
                        this.tweens.add({
                            targets: title,
                            alpha: 1,
                            duration: 500,
                            ease: 'Power2',
                            onComplete: () => {
                                this.tweens.add({
                                    targets: subtitle,
                                    alpha: 1,
                                    duration: 500,
                                    ease: 'Power2',
                                    onComplete: () => {
                                        this.tweens.add({
                                            targets: this.btnDownload,
                                            alpha: 1,

                                            duration: 700,
                                            ease: 'Power2',
                                            onComplete: () => {
                                                this.tweens.add({
                                                    targets: this.btnBackToMenu,
                                                    alpha: 1,

                                                    duration: 700,
                                                    ease: 'Power2',
                                                    onComplete: () => {
                                                        this.tweens.add({
                                                            targets: this.btnClose,
                                                            alpha: 1,
                                                            duration: 700,
                                                            ease: 'Power2',
                                                            onComplete: () => {
                                                                this.tweens.add({
                                                                    targets: subtitle2,
                                                                    alpha: 1,
                                                                    duration: 500,
                                                                    ease: 'Power2',
                                                                });
                                                            },
                                                        });
                                                    },
                                                });
                                            },
                                        });
                                    },
                                });
                            },
                        });
                    },
                });
            },
        });

        // click events
        this.btnDownload.on('pointerdown', () => {
            window.open('./assets/l-oreal_sga_pocket_memo.pdf', '_blank');
        });
        this.btnBackToMenu.on('pointerdown', () => {
            this.scene.restart();
            this.scene.start('Menu');
        });

        this.btnClose.on('pointerdown', () => {
            scormQuit();
            this.scene.restart();
            this.scene.start('Close');
        });

        // Logo L'Oréal
        this.add
            .image(this.width - 100, this.height - 50, 'logoLoreal')
            .setOrigin(0.5, 0.5)
            .setScale(0.5, 0.5);
    }
}
